module.exports = __webpack_public_path__ + "img/921345088.3ba6b566.jpg";